module.exports = __webpack_public_path__ + "static/dominikawork1-5ea58af7e4b386e6a9f9975534ac376b.jpg";